<template>
  <div class="page-title">
    <div>
      <b-row class="row-title">
        <b-col class="text-left">
          <i v-if="isBack" class="fa fa-arrow-circle-left icon-back" @click="clickBack"></i>
        </b-col>
        <b-col>
          <i v-if="icon" :class="icon" :style="{fontSize: fontSize + 'px'}"></i>
          <span class="ml-3" :style="{fontSize: fontSize + 'px'}">{{ title }}</span>
        </b-col>
        <b-col class="text-right">
          <img
            src="@/assets/general/messager1.png"
            @click="clickReadNotification"
            class="message-notification"
            :class="countInfo > 0 ? 'fa-blink' : ''"
            width="40px"
            alt="mensagens"
          >
          <b-badge class="count-message" variant="danger">{{countInfo == 0 ? '' : countInfo}}</b-badge>
        </b-col>
      </b-row>

      <!-- modal notificações -->
      <vs-popup title="Notificações" :active.sync="showNotification">
        <Notification/>
      </vs-popup>
    </div>
    <hr>
  </div>
</template>

<script>
//components
import Notification from "@/components/template/Notification";
//eventos
import { EventBusNotification } from "@/eventBus/eventBusNotification";

export default {
  name: "PageTitle",
  components: { Notification },
  props: ["icon", "title", "fontSize", "link", "isBack"],
  data() {
    return {
      showNotification: false,
      countInfo: null,
      userContext: this.$store.state.userContext
    };
  },
  methods: {
    clickBack() {
      this.$router.push({ name: this.link });
    },
    clickReadNotification() {
      this.showNotification = true;
    }
  },
  mounted() {
    //atualiza notificações
    EventBusNotification.$on("notificationMessage", countInfo => {
      this.countInfo = countInfo;
    });
    EventBusNotification.$on("readMessage", () => {
      this.countInfo--;
    });
  }
};
</script>

<style>
.page-title {
  grid-area: pageTitle;
}

.page-title h4 {
  margin: 0px;
}
.row-title {
  margin-top: 10px;
}

.page-title i,
span {
  color: #147dbf;
}

.title-h1 {
  font-size: 40px;
}

.title-h4 {
  font-size: 20px;
}

.icon-back {
  font-size: 30px;
  cursor: pointer;
}

.icon-back:hover {
  -webkit-transform: scale(1.2);
  -ms-transform: scale(1.2);
  transform: scale(1.2);
  transition: 1s ease;
}

.message-notification {
  cursor: pointer;
}

.message-notification:hover {
  -webkit-transform: scale(1.2);
  -ms-transform: scale(1.2);
  transform: scale(1.2);
  transition: 1s ease;
}

.notification-header-box {
  font-size: 18px;
  font-weight: bold;
  color: #147dbf;
}

.notification-content-box {
  font-size: 16px;
  font-weight: bold;
  color: rgba(3, 19, 20, 0.74);
}

@keyframes fa-blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}

.fa-blink {
  -webkit-animation: fa-blink 0.75s linear infinite;
  -moz-animation: fa-blink 0.75s linear infinite;
  -ms-animation: fa-blink 0.75s linear infinite;
  -o-animation: fa-blink 0.75s linear infinite;
  animation: fa-blink 0.75s linear infinite;
}

hr {
  margin-top: 1px;
  color: #6d0a0a3f;
}

/* área responsiva */
@media screen and (max-width: 450px) {
  .row-title {
    display: block;
  }
}
</style>